import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { UpdateUserIdPostRequestModel, UpdateUserIdPostResponseModel } from "@/features/user/services/user-model";

export class UpdateUserIdApi {
  /**
   * 利用者ID変更API
   */
  public postUpdateUserId = async (
    param: UpdateUserIdPostRequestModel
  ): Promise<UpdateUserIdPostResponseModel> => {
    const path = `/api/users/updateid`;

    const res = await ApiClient.instance.post<UpdateUserIdPostResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
